export default "/static/webpack/media/no-round.6b9b11e8.svg";